import EnterpriseAccountContent from './enterprise-account-content';

export default EnterpriseAccountContent;
